import { render, staticRenderFns } from "./AttributeCreate.vue?vue&type=template&id=588df372"
import script from "./AttributeCreate.vue?vue&type=script&lang=js"
export * from "./AttributeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports